import type { Action } from 'redux';
import { createSelector } from 'reselect';
import {
  HIDE_NAVIGATION_MODAL,
  SHOW_NAVIGATION_MODAL,
  SHOW_BONUS_CONFIRM_BONUS_MODAL,
  HIDE_BONUS_CONFIRM_BONUS_MODAL,
  SHOW_SORT_PROVIDERS_MODAL,
  HIDE_SORT_PROVIDERS_MODAL,
  SHOW_CURRENCY_CONFIRM_MODAL,
  HIDE_CURRENCY_CONFIRM_MODAL,
  SHOW_RECENTS_GAMES_MIGRATION_PROCESS_MODAL,
  HIDE_RECENTS_GAMES_MIGRATION_PROCESS_MODAL,
  SHOW_LOSS_LIMITS_MODAL,
  HIDE_LOSS_LIMITS_MODAL,
} from '../../constants/modals';
import type { RootState } from '../../store';

export interface ModalsState {
  isNavigationOpen: boolean;
  isBonusConfirmOpen: boolean;
  isSortingProvidersOpen: boolean;
  isCurrencyConfirmOpen: boolean;
  isRecentGamesModalOpen: boolean;
  isLossLimitsModalOpen: boolean;
}

export const initialState = {
  isNavigationOpen: false,
  isBonusConfirmOpen: false,
  isSortingProvidersOpen: false,
  isCurrencyConfirmOpen: false,
  isRecentGamesModalOpen: false,
  isLossLimitsModalOpen: false,
};

const reducer = (state = initialState, action: Action): ModalsState => {
  switch (action.type) {
    case SHOW_NAVIGATION_MODAL:
      return { ...state, isNavigationOpen: true };
    case HIDE_NAVIGATION_MODAL:
      return { ...state, isNavigationOpen: false };
    case SHOW_SORT_PROVIDERS_MODAL:
      return { ...state, isSortingProvidersOpen: true };
    case HIDE_SORT_PROVIDERS_MODAL:
      return { ...state, isSortingProvidersOpen: false };
    case SHOW_BONUS_CONFIRM_BONUS_MODAL:
      return { ...state, isBonusConfirmOpen: true };
    case HIDE_BONUS_CONFIRM_BONUS_MODAL:
      return { ...state, isBonusConfirmOpen: false };
    case SHOW_CURRENCY_CONFIRM_MODAL:
      return { ...state, isCurrencyConfirmOpen: true };
    case HIDE_CURRENCY_CONFIRM_MODAL:
      return { ...state, isCurrencyConfirmOpen: false };
    case SHOW_RECENTS_GAMES_MIGRATION_PROCESS_MODAL:
      return { ...state, isRecentGamesModalOpen: true };
    case HIDE_RECENTS_GAMES_MIGRATION_PROCESS_MODAL:
      return { ...state, isRecentGamesModalOpen: false };
    case SHOW_LOSS_LIMITS_MODAL:
      return { ...state, isLossLimitsModalOpen: true };
    case HIDE_LOSS_LIMITS_MODAL:
      return { ...state, isLossLimitsModalOpen: false };
    default:
      return state;
  }
};

export default reducer;

/**
 * SELECTOR
 */
export const modalsSelector = (state: RootState) => {
  return state?.ui?.modals || initialState;
};

export const isRecentGamesMigrationModalOpenedSelector = createSelector(
  modalsSelector,
  (state) =>
    state?.isRecentGamesModalOpen ?? initialState.isRecentGamesModalOpen
);

export const isNavigationOpenSelector = createSelector(
  modalsSelector,
  isRecentGamesMigrationModalOpenedSelector,
  (state, isRecentsModalOpened) =>
    !isRecentsModalOpened &&
    (state?.isNavigationOpen ?? initialState.isNavigationOpen)
);

export const isSortingProvidersOpenSelector = createSelector(
  modalsSelector,
  isRecentGamesMigrationModalOpenedSelector,
  (state, isRecentsModalOpened) =>
    !isRecentsModalOpened &&
    (state?.isSortingProvidersOpen ?? initialState.isSortingProvidersOpen)
);

export const isBonusConfirmOpenSelector = createSelector(
  modalsSelector,
  isRecentGamesMigrationModalOpenedSelector,
  (state, isRecentsModalOpened) =>
    !isRecentsModalOpened &&
    (state?.isBonusConfirmOpen ?? initialState.isBonusConfirmOpen)
);

export const isCurrencyConfirmOpenSelector = createSelector(
  modalsSelector,
  isRecentGamesMigrationModalOpenedSelector,
  (state, isRecentsModalOpened) =>
    !isRecentsModalOpened &&
    (state?.isCurrencyConfirmOpen ?? initialState.isCurrencyConfirmOpen)
);
export const isLossLimitsModalOpenSelector = createSelector(
  modalsSelector,
  isRecentGamesMigrationModalOpenedSelector,
  (state, isRecentsModalOpened) =>
    !isRecentsModalOpened &&
    (state?.isLossLimitsModalOpen ?? initialState.isLossLimitsModalOpen)
);
